export function debounce(func, waitMilliseconds, options) {
    var _a, _b;
    if (waitMilliseconds === void 0) { waitMilliseconds = 50; }
    if (options === void 0) { options = {}; }
    var timeoutId;
    var isImmediate = (_a = options.isImmediate) !== null && _a !== void 0 ? _a : false;
    var callback = (_b = options.callback) !== null && _b !== void 0 ? _b : false;
    var maxWait = options.maxWait;
    var lastInvokeTime = Date.now();
    var promises = [];
    function nextInvokeTimeout() {
        if (maxWait !== undefined) {
            var timeSinceLastInvocation = Date.now() - lastInvokeTime;
            if (timeSinceLastInvocation + waitMilliseconds >= maxWait) {
                return maxWait - timeSinceLastInvocation;
            }
        }
        return waitMilliseconds;
    }
    var debouncedFunction = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        return new Promise(function (resolve, reject) {
            var invokeFunction = function () {
                timeoutId = undefined;
                lastInvokeTime = Date.now();
                if (!isImmediate) {
                    var result_1 = func.apply(context, args);
                    callback && callback(result_1);
                    promises.forEach(function (_a) {
                        var resolve = _a.resolve;
                        return resolve(result_1);
                    });
                    promises = [];
                }
            };
            var shouldCallNow = isImmediate && timeoutId === undefined;
            if (timeoutId !== undefined) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(invokeFunction, nextInvokeTimeout());
            if (shouldCallNow) {
                var result = func.apply(context, args);
                callback && callback(result);
                return resolve(result);
            }
            promises.push({ resolve: resolve, reject: reject });
        });
    };
    debouncedFunction.cancel = function (reason) {
        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
        }
        promises.forEach(function (_a) {
            var reject = _a.reject;
            return reject(reason);
        });
        promises = [];
    };
    return debouncedFunction;
}
